import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class BrownFloor extends Floor {
	static key = "BrownFloor";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): BrownFloor {
		const f = new BrownFloor(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
